import React from 'react';
import { Theme, Dialog as MuiDialog, DialogContent, DialogTitle } from '@mui/material';

import { InfoDialogProps } from './types';

import { CloseIcon } from '../../icons';
import { IconButton } from '../IconButton';

export const InfoDialog = (props: InfoDialogProps) => {
  const { children, dialogTitle, open, onClose, dialogTitleProps, ...rest } = props;

  return (
    <MuiDialog open={open} onClose={onClose} scroll='body' {...rest}>
      <DialogTitle {...dialogTitleProps}>{dialogTitle}</DialogTitle>

      {!props.hideCloseButton && (
        <IconButton
          size='medium'
          onClick={onClose}
          sx={(theme: Theme) => ({
            position: 'absolute',
            right: theme.spacing(1),
            top: theme.spacing(0.5),
          })}
        >
          <CloseIcon fontSize='inherit' />
        </IconButton>
      )}

      <DialogContent>{children}</DialogContent>
    </MuiDialog>
  );
};
